<template>
  <div class="about">
    <h1>关于页面</h1>
    <p>这是一个基础的Vue项目框架</p>
    <el-button @click="goBack">返回首页</el-button>
  </div>
</template>

<script>
export default {
  name: 'About',
  methods: {
    goBack() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.about {
  text-align: center;
  padding: 60px 20px;
}

h1 {
  color: #303133;
  margin-bottom: 20px;
}

p {
  color: #606266;
  margin-bottom: 30px;
}
</style>